import { precompileTemplate } from "@ember/template-compilation";
export default precompileTemplate("{{this.content}}\n")